import React from 'react';
import { useParams } from 'react-router-dom';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import { Logo } from 'Components/logo';
import { Pathname } from 'Routes';
import styles from './Referral.module.css';

// Referral landing page. Reached via a shared affiliate link
// (`/referral/:code`). Lets the visitor choose whether they're creating an
// account for themselves or gifting to someone else, then routes them to the
// matching flow while preserving the affiliate code.
function Referral() {
  const { code } = useParams();

  // Same-app signup/login flow — used by both the "Yourself" tile and the
  // "Log in" link. Kept on the current origin so it works across environments.
  const signInUrl = `${window.location.origin}${Pathname.authentication.newSignUp}?referral=${code}`;

  const goToSelfSignup = () => {
    window.location.href = signInUrl;
  };

  const goToGift = () => {
    // Gifting lives on the marketing domain, so this is an external redirect.
    window.location.href = `${window.location.origin}/gift/${code}`;
  };

  return (
    <div className={styles.page}>
      <div className={styles.logoWrap}>
        <Logo />
      </div>

      <div className={styles.card}>
        <h1 className={styles.title}>Create Account For?</h1>
        <p className={styles.subtitle}>Choose how you&apos;d like to get started.</p>

        <div className={styles.options}>
          <div
            className={styles.option}
            role="button"
            tabIndex={0}
            onClick={goToSelfSignup}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') goToSelfSignup(); }}
          >
            <span className={styles.optionIcon}>
              <PersonOutlineIcon fontSize="inherit" />
            </span>
            <span className={styles.optionTitle}>Yourself</span>
            <span className={styles.optionDesc}>Set up your own Projector account</span>
          </div>

          <div
            className={styles.option}
            role="button"
            tabIndex={0}
            onClick={goToGift}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') goToGift(); }}
          >
            <span className={styles.optionIcon}>
              <CardGiftcardIcon fontSize="inherit" />
            </span>
            <span className={styles.optionTitle}>For Someone Else</span>
            <span className={styles.optionDesc}>Send Projector as a gift to a loved one</span>
          </div>
        </div>

        <p className={styles.loginPrompt}>
          Already have an account?
          <a className={styles.loginLink} href={signInUrl}>Log in</a>
        </p>
      </div>
    </div>
  );
}

export default Referral;
